import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { key: 2 }
const _hoisted_3 = { key: 3 }
const _hoisted_4 = {
  key: 4,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", null, "N.Identificação:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Pessoa:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("b", null, "Vencimento:", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "Valor Disponível:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("b", null, "Valor Utilizado:", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", null, "Conta:", -1)
const _hoisted_11 = {
  class: "ant-row",
  style: {"margin":"10px 0px"}
}
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_totalizador = _resolveComponent("totalizador")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, {
    titulo: "CRÉDITOS DISPONÍVEIS",
    class: "ss-alinhar-texto-esquerda"
  }, {
    AcoesExtra: _withCtx(() => [
      _createVNode(_component_a_checkbox, {
        style: {"float":"right"},
        checked: _ctx.state.computedUtilizarCreditosApenasMesmaPessoa,
        "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.computedUtilizarCreditosApenasMesmaPessoa) = $event))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Utilizar crédito apenas nos títulos da mesma Pessoa")
        ]),
        _: 1
      }, 8, ["checked"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_table, {
        columns: _ctx.gradeBase.colunas.filter(item => item.visible),
        "data-source": _ctx.state.computedCreditosUtilizados,
        pagination: false,
        loading: _ctx.telaBase.carregando,
        scroll: _ctx.gradeBase.layoutMobile?null: { x: (_ctx.gradeBase.windowWidth), y: 500 },
        size: "small"
      }, {
        bodyCell: _withCtx(({ column, record,index, text }) => [
          (column.key === 'ValorUtilizado')
            ? (_openBlock(), _createBlock(_component_campo_numerico, {
                key: 0,
                valor: record.valorUtilizado,
                "onUpdate:valor": ($event: any) => ((record.valorUtilizado) = $event),
                onChange: ($event: any) => (_ctx.estrategiaValorUtilizadoAlterado(index)),
                classCss: "ss-campo-numero-table",
                valorMaximo: record.saldo
              }, null, 8, ["valor", "onUpdate:valor", "onChange", "valorMaximo"]))
            : (column.key === 'TipoDocumentoFinanceiro')
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  title: record.descricaoTipoDocumentoFinanceiro
                }, _toDisplayString(record.siglaTipoDocumentoFinanceiro), 9, _hoisted_1))
              : (column.customRenderRow === _ctx.ECustomRenderRow.MascararData)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                : (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text,2)), 1))
                  : (column.key === 'Credito')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("span", null, [
                          _hoisted_5,
                          _createTextVNode(" " + _toDisplayString(record.numeroTitulo), 1)
                        ]),
                        _createElementVNode("span", null, [
                          _hoisted_6,
                          _createTextVNode(" " + _toDisplayString(record.nomePessoa), 1)
                        ]),
                        _createElementVNode("span", null, [
                          _hoisted_7,
                          _createTextVNode(" " + _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.dataVencimento)), 1)
                        ]),
                        _createElementVNode("span", null, [
                          _hoisted_8,
                          _createTextVNode(" R$ " + _toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.saldo,2)), 1)
                        ]),
                        _createElementVNode("span", null, [
                          _hoisted_9,
                          _createTextVNode(),
                          _createVNode(_component_campo_numerico, {
                            monetario: true,
                            valor: record.valorUtilizado,
                            "onUpdate:valor": ($event: any) => ((record.valorUtilizado) = $event),
                            onChange: ($event: any) => (_ctx.estrategiaValorUtilizadoAlterado(index)),
                            classCss: "ss-campo-numero-table",
                            valorMaximo: record.saldo
                          }, null, 8, ["valor", "onUpdate:valor", "onChange", "valorMaximo"])
                        ]),
                        _createElementVNode("span", null, [
                          _hoisted_10,
                          _createTextVNode(" " + _toDisplayString(record.descricaoConta), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
        ]),
        emptyText: _withCtx(() => [
          (_ctx.state.quantidadeCreditos <= 0)
            ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                key: 0,
                mensagem: "Nenhum crédito disponível para ser utilizado"
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["columns", "data-source", "loading", "scroll"]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_totalizador, {
            titulo: "QTDE CRÉDITOS",
            monetario: false,
            valor: _ctx.state.quantidadeCreditos,
            casasDecimais: 0
          }, null, 8, ["valor"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_totalizador, {
            titulo: "TOTAL CRÉDITOS DISPONÍVEIS",
            monetario: true,
            valor: _ctx.state.totalCreditosDisponiveis
          }, null, 8, ["valor"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_totalizador, {
            titulo: "TOTAL CRÉDITOS UTILIZADOS",
            monetario: true,
            valor: _ctx.state.totalCreditosUtilizados
          }, null, 8, ["valor"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_totalizador, {
            titulo: "TOTAL BAIXA TÍTULOS",
            monetario: true,
            valor: _ctx.props.totalBaixa
          }, null, 8, ["valor"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_a_tooltip, {
            placement: "top",
            title: "(Total Créditos Utilizados + Total Novos Títulos + Total Recebimentos) - Total Baixa Títulos"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_totalizador, {
                titulo: "VALOR RESTANTE",
                monetario: true,
                valor: _ctx.props.valorRestante
              }, null, 8, ["valor"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}